$(function () {
  $(".grid-product").each(function () {
    let $this = $(this);
    $(this)
      .find(".color-swatch")
      .hover(
        function () {
          $this.find(".color-swatch").addClass("unhovered-collection-swatch");
          $(this).removeClass("unhovered-collection-swatch");
          $(this).addClass("hovered-collection-swatch");
        },
        function () {
          $this
            .find(".color-swatch")
            .removeClass("unhovered-collection-swatch");
          $this.find(".color-swatch").removeClass("hovered-collection-swatch");
        }
      );
  });

  $(".no-hover-image").hover(
    function () {
      $(this).find(".image-wrap").css("opacity", "0.16");
    },
    function () {
      $(this).find(".image-wrap").css("opacity", "1");
    }
  );

  $(".collection-filter-button").click(function (e) {
    e.preventDefault();

    $(".template-collection").addClass("filter-clicked");

    let tagName = $(this).text();

    $(".collection-filter-button").removeClass("selected-filter");
    $(this).addClass("selected-filter");

    if (tagName == "All") {
      $(".collection-grid__wrapper .grid__item").show();
    } else {
      $(".collection-grid__wrapper .grid__item").show();

      $(".collection-grid__wrapper .grid__item").each(function () {
        let productTagsRaw = $(this).attr("data-product-tags");
        let productTagsArray = JSON.parse(productTagsRaw);

        if (productTagsArray.includes(tagName)) {
        } else {
          $(this).hide();
        }
      });
    }
  });
});

//compare functions

function compareCheckbox() {
  let checkBox = document.querySelectorAll("#compare-checkbox:checked");
  const checkboxAmount = checkBox.length;
  let productToCompare = [];
  let productHandleStorage = [];
  let specsConnectivityStorage =[];
  let specsPowerStorage = [];
  let specsFeaturesStorage = [];
  let specsDimensionsStorage = [];
  var str = "<!-- -->";
  
  //let productHandle = this.getAttribute("value");

  //check how many boxes are checked, max of 4
  if (checkboxAmount > 4) {
    alert("Please Only Select 4 Products to Compare");
    event.preventDefault();
  } else if (checkboxAmount > 0) {
    //make compare drawer visible, invisible
    document.getElementById("compare-drawer-container").style.visability =
      "visible";
    document.getElementById("compare-drawer-container").style.opacity = "1";
    document.getElementById("compare-drawer-container").style.bottom = "0";

    //build compare items in drawer

    for (let i = 0; i < checkBox.length; i++) {
      let urlImage = checkBox[i].getAttribute("data-imageurl");
      productToCompare[checkBox[i].getAttribute("value")] =
        checkBox[i].getAttribute("data-imageurl");
      str +=
        '<div class="compare-item" data-item="' +
        checkBox[i].getAttribute("value") +
        '"><image class="lazyload" src="' +
        checkBox[i].getAttribute("data-imageurl") +
        '" ><span class="compare-close-drawer">X</span></div>';
      document.querySelector(".compare-drawer-items").innerHTML = str;
      
      productHandleStorage.push(checkBox[i].getAttribute("value"));
      specsConnectivityStorage.push(checkBox[i].getAttribute("data-connectivity"));
      specsPowerStorage.push(checkBox[i].getAttribute("data-power"));
      specsFeaturesStorage.push(checkBox[i].getAttribute("data-features"));
      specsDimensionsStorage.push(checkBox[i].getAttribute("data-dimensions"));
      console.log(checkBox[i].getAttribute("data-dimensions"));
      
    }
    //disable compare button if less than 2 items are selected
    if (checkboxAmount < 2) {
      document
        .querySelector(".compare-button")
        .setAttribute("disabled", "disabled");
    } else {
      document.querySelector(".compare-button").removeAttribute("disabled");
    }

    //hide drawer
  } else if (checkboxAmount == 0) {
    document.getElementById("compare-drawer-container").style.visability =
      "hidden";
    document.getElementById("compare-drawer-container").style.opacity = "0";
    document.getElementById("compare-drawer-container").style.bottom = "-200px";
  }

  // remove item from drawer functionality

  var drawerClosebtns = document.getElementsByClassName("compare-close-drawer");
  var n;
  for (n = 0; n < drawerClosebtns.length; n++) {
    drawerClosebtns[n].addEventListener("click", function () {
      let drawerItem = this.parentElement.getAttribute("data-item");
      let drawerItemChecked = document.querySelector(
        '[value="' + CSS.escape(drawerItem) + '"]'
      );
      drawerItemChecked.click();
    });
  }
  
  window.localStorage.setItem("productHandles",JSON.stringify(productHandleStorage));
  window.localStorage.setItem("productConnectivity",JSON.stringify(specsConnectivityStorage));
  window.localStorage.setItem("productPower",JSON.stringify(specsPowerStorage));
  window.localStorage.setItem("productFeatures",JSON.stringify(specsFeaturesStorage));
  window.localStorage.setItem("productDimensions",JSON.stringify(specsDimensionsStorage));
 
}
